import { useState } from 'react';

import { SvgTooltip } from './svg-tooltip';
import { svgTooltipConfig } from './svg-tooltip.config';

export type UseSvgTooltipParams = {
	cx: number;
	cy: number;

	// defaults in config
	fontSize?: number;
	padding?: [number, number, number, number];
};

export const useSvgTooltip = (props: UseSvgTooltipParams) => {
	const {
		cx,
		cy,
		fontSize = svgTooltipConfig.fontSize,
		padding = svgTooltipConfig.padding as [number, number, number, number]
	} = props;

	const [tooltips, setTooltips] = useState<{key: string, tooltip: string}[]>([]);

	// try to only keep one entry, last set wins.
	const setTooltip = (key: string, tooltip: string) => {
		setTooltips([{ key, tooltip }]);
	};

	// using a key, just in case set/clear are called out of order
	const clearTooltip = (key: string) => {
		setTooltips(tooltips.filter((t) => t.key !== key));
	}

	const currentTooltip = tooltips.length > 0 ? tooltips[tooltips.length - 1].tooltip : '';

	const renderProps = {
		tooltip: currentTooltip,
		cx,
		cy,
		fontSize,
		padding
	};
	const renderTooltip = <SvgTooltip {...renderProps} />

	return {
		currentTooltip: tooltips.length > 0 ? tooltips[tooltips.length - 1].tooltip : '',
		setTooltip,
		clearTooltip,
		renderTooltip
	};
};

